<template>
  <div class="common_button_switch" :class="{ 'active': switchState }" @click="switchHandle" />
</template>

<script>
export default {
  name: 'SwitchCheckbox',

  props: {
    value: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return { switchState: this.value }
  },

  watch: {
    value (newVal) {
      this.switchState = newVal
    }
  },

  methods: {
    switchHandle () {
      this.switchState = !this.switchState
      this.$emit('input', this.switchState)
      this.$emit('getState', this.switchState)
    }
  }
}
</script>

<style lang="scss" scoped>
.common_button_switch {
  position: relative;
  width: 34px;
  height: 16px;
  cursor: pointer;
  background-color: $btn_color_disable;
  border-radius: 8px;

  &::before { position: absolute; top: 2px; left: 2px; width: 12px; height: 12px; content: ''; background-color: #fff; border-radius: 50%; }
  &.active { background-color: $btn_color_default;
    &::before { right: 2px; left: auto; }
  }
}
</style>
